import React from 'react';
import request from 'arcdynamic-request';
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";

class SelectTeam extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
        };
    }

    componentDidMount() {
        request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.datasource.table.Data.getData',
            params: ['code', 'TEAM', {
                limit: {
                    count: 1000,
                    offset: 0,
                },
                column: [
                    'ARCIMEDES_ROW_ID',
                    'FIRST_NAME',
                    'LAST_NAME',
                    'DELETED',
                ],
                filter: [
                    {
                        code: 'FIRST_NAME',
                        text: '',
                        type: 'notNull',
                    },
                    {
                        code: 'LAST_NAME',
                        text: '',
                        type: 'notNull',
                    },
                ],
                filterType: 'and',
                order: [
                    {
                        code: 'FIRST_NAME',
                        type: 'asc',
                    },
                    {
                        code: 'LAST_NAME',
                        type: 'asc',
                    },
                ],
            }],
        }).then(res => {
            let items = res.data ? res.data.filter(x => x.FIRST_NAME && x.LAST_NAME) : false;
            this.setState({items});
        });
    }

    render() {
        const { 
            theme, 
            value, 
            valueKey, 
            label, 
            disabled, 
            data, 
            isFilter, 
            handleParentChange,
            handleInputParentChange,
            viewMode,
            deleted,
            isFromProperty,
            hasAgentPercent,
            ...rest,
        } = this.props;
        const { items } = this.state;
        const inactive = items && items.filter(x => x.DELETED === 'y') || [];
        const active = items && items.filter(x => x.DELETED !== 'y') || [];
        let itemsSorted = [...active, ...inactive];

        itemsSorted = itemsSorted.map((el) => {
            el.groupedBy = el.DELETED !== 'y' ? 'active' : 'inactive';
            return el
        });

        return (
            <Dropdown theme={theme}
                      optionsType='team'
                      optionKey='ARCIMEDES_ROW_ID'
                      options={itemsSorted}
                      value={value}
                      valueKey={valueKey}
                      label={label}
                      disabled={!items || disabled}
                      data={data}
                      isFilter={isFilter}
                      groupBy={true}
                      handleParentChange={handleParentChange}
                      handleInputParentChange={handleInputParentChange}
                      viewMode={viewMode}
                      deleted={deleted}
                      isFromProperty={isFromProperty}
                      hasAgentPercent={hasAgentPercent}
                      {...rest}
            />
        )
    }
}

SelectTeam.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    groupBy: PropTypes.bool,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
    hasAgentPercent: PropTypes.bool,
    handleInputParentChange: PropTypes.func,
};

export default SelectTeam;
